import {ReportName} from 'common/report/constants';
import {BaseClient} from 'common/report/queries/utils/base-client';

import {ExperimentQueryParams} from './types';

class ExperimentsClient extends BaseClient {
  public buildEndpoint({isSegmentsQuery}) {
    if (isSegmentsQuery) {
      return `api/2.0/experiments/segments/`;
    }
    return `api/2.0/experiments/`;
  }

  public buildQueryParams(params: ExperimentQueryParams) {
    return {
      project_id: params.projectId,
      ...(params.workspaceId ? {workspace_id: params.workspaceId} : {}),
    };
  }

  // params argument is declared optional to avoid conflicting with BaseClient's Javascript no-argument function declaration
  public buildRequestBody(params?: ExperimentQueryParams) {
    const trackingProps = {
      report_name: ReportName.ExperimentReporting,
      is_main_query_for_report: params.isMainQueryForReport,
    };

    if (params.isSegmentsQuery === true) {
      // as silly as this looks, it's needed to trigger typescript's discriminant property check
      return JSON.stringify({
        bookmark_id: params.bookmarkId,
        date_range_override: params.dateRangeOverride,
        trend_unit: params.trendUnit,
        tracking_props: trackingProps,
      });
    } else {
      return JSON.stringify({
        bookmark_id: params.bookmarkId,
        control: params.control,
        treatments: params.treatments,
        date_range_override: params.dateRangeOverride,
        trend_unit: params.trendUnit,
        segment: params.segment,
        tracking_props: trackingProps,
      });
    }
  }

  public processResponse(response) {
    return response;
  }
}

export const experimentsClient = new ExperimentsClient();
